<template>
  <div class="home">
    <div class="container">
      <h1>העלאת תכני יוטיוב ל-Google Drive</h1>
      <h2>לסרטונים, פלייליסטים וערוצים הפתוחים בנטפרי</h2>
      
      <div class="auth-section">
        <google-auth @auth-changed="checkAuth" />
      </div>
      
      <div class="upload-section" v-if="isAuthenticated">
        <video-uploader ref="uploader" />
      </div>
    </div>
  </div>
</template>

<script>
import GoogleAuth from '@/components/GoogleAuth.vue';
import VideoUploader from '@/components/VideoUploader.vue';
import AuthService from '@/services/auth';

export default {
  name: 'HomePage',
  components: {
    GoogleAuth,
    VideoUploader
  },
  data() {
    return {
      isAuthenticated: false
    };
  },
  created() {
    this.checkAuth();
  },
  methods: {
    checkAuth() {
      this.isAuthenticated = AuthService.isAuthenticated();
    }
  }
}
</script>

<style scoped>
.container {
  max-width: 800px;
  margin: 40px auto;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  padding: 30px;
}

h1, h2 {
  color: var(--primary-color);
  text-align: center;
  margin-bottom: 20px;
}

h2 {
  font-size: 1.2rem;
}

.auth-section, .upload-section {
  margin-bottom: 30px;
  padding: 20px;
  border-radius: 8px;
  background-color: #f7f9fc;
}
</style>
